import AddTaskIcon from "@mui/icons-material/AddTask";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {
    Autocomplete,
    CircularProgress,
    FormHelperText,
    IconButton,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import React, { useEffect, useState, useRef } from "react";
import Grid from "@mui/material/Grid2";
import { fetchData } from "../../services/UtilService";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormLabel from "@mui/material/FormLabel";
import FormControlLabel from "@mui/material/FormControlLabel";

import {
    REPORT_URL,
    REPORT_UPDATE_URL,
    ASSET_ITEM_URL,
    DEPARTMETNS_URL,
    ORG_URL,
    IMPACTS_URL,
    PRIORITIES_URL,
    REQUEST_TYPE_URL,
    RESOLVER_GROUP_URL,
    RESOLVER_BY_RG_URL,
    REPORT_DOWNLOAD_BUILDER_URL,
} from "../../Constants/Constants";
import { STATUS_SEQ_ID } from "../../Constants/StatusConstants";
import AxiosInstance from "../../services/AxiosInstance";
import { ThemeProvider } from "../v2/home/theme/ThemeProvider";
import { useAlert } from "./../alerts//AlertContext";
import { hasRole } from "../../auth/authService";
import { ROLE_ADMIN } from "../../Constants/RolesConstants";
import { isEmpty } from "../../Constants/RolesConstants";
import { Link } from "react-router-dom";

function ReportDialog({ reportId, selectedReportName, fetchReports, componentPermissions, actionType }) {


    const initialized = useRef(false);
    const showAlert = useAlert();

    const [id, setId] = useState();
    const [name, setName] = useState();
    const [organizations, setOrganizations] = useState([]);
    const [requestTypes, setRequestTypes] = useState([]);
    const [priorities, setPriorities] = useState([]);
    const [assetItems, setAssetItems] = useState([]);
    const [resolverGroups, setResolverGroups] = useState([]);
    const [resolvers, setResolvers] = useState([]);

    const [organization, setOrganization] = useState();
    const [requestType, setRequestType] = useState();
    const [priority, setPriority] = useState();
    const [assetItem, setAssetItem] = useState();
    const [resolverGroup, setResolverGroup] = useState();
    const [resolver, setResolver] = useState();
    const [active, setActive] = useState(true);

    const [open, setOpen] = useState(false);

    const [reportData, setReportData] = useState({
        id: "",
        name: "",
        organization: { id: '' },
        requestType: { id: '' },
        priority: { id: '' },
        assetItem: { id: '' },
        resolverGroup: { id: '' },
        resolver: { id: '' },
        active: '',
    });



    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true;
            fetchData(ORG_URL)
                .then((data) => setOrganizations(data.data))
                .catch((err) => console.log("Failed to fetch data"));
            fetchData(REQUEST_TYPE_URL)
                .then((data) => setRequestTypes(data))
                .catch((err) => console.log("Failed to fetch data"));
            fetchData(ASSET_ITEM_URL)
                .then((data) => setAssetItems(data.data))
                .catch((err) => console.log("Failed to fetch data"));
            fetchData(PRIORITIES_URL)
                .then((data) => setPriorities(data.data))
                .catch((err) => console.log("Failed to fetch data"));
            fetchData(RESOLVER_GROUP_URL)
                .then((data) => setResolverGroups(data.data))
                .catch((err) => console.log("Failed to fetch data"));
        }

    }, []);

    const handlePriorityChange = (event) => {
        setPriority(event.target.value);
    };

    const handleResolverGroupChange = (event) => {
        setResolverGroup(event.target.value);

        if (event.target.value !== null && event.target.value !== "") {
            console.log("resolver url:" + RESOLVER_BY_RG_URL + event.target.value);
            AxiosInstance.get(`${RESOLVER_BY_RG_URL}/${event.target.value}`).then(
                (response) => setResolvers(response.data)
            );
        } else {
            setResolvers(null);
        }
    };

    const handleResolverChange = (event) => {
        setResolver(event.target.value);
    };

    const handleOrgChange = (event) => {
        setOrganization(event.target.value);
    };

    const handleRequestTypeChange = (event) => {
        setRequestType(event.target.value);
    };

    const handleAssetItemChange = (event) => {
        setAssetItem(event.target.value);
    };

    const handleStatusChange = (event) => {
        setActive(event.target.value);
    };

    const handleClickOpen = () => {

        if (reportId !== 0) {
            getReport();
        } else {
            setOpen(true);
        }

    };

    const handleClose = () => {
        setOpen(false);
    };

    const getReport = async () => {
        await AxiosInstance.get(REPORT_URL + reportId).then((response) => {
            var reportData = response.data;
            setReportData(reportData);
            setId(reportData.id);
            setName(reportData.name);
            setOrganization(reportData.organizationId);
            setRequestType(reportData.requestTypeId);
            setPriority(reportData.priorityId);
            setAssetItem(reportData.assetItemId);
            setResolverGroup(reportData.resolverGroupId);
            //setResolver(reportData.resolverId);  
            if (reportData.resolverGroupId !== '' && reportData.resolverGroupId !== null && reportData.resolverGroupId !== 0) {
                fetchData(`${RESOLVER_BY_RG_URL}/${reportData.resolverGroupId}`)
                    .then((data) => {
                        setResolvers(data);
                        setResolver(reportData.resolverId);
                    })
                    .catch((err) => console.log("Failed to fetch data"));
            }


            setActive(reportData.active);
            setOpen(true);
        });
    };

    const saveReport = () => {
        var reportObj = {};
        if (reportId !== 0)
            reportObj.id = id;

        reportObj.name = name;
        reportObj.organization = { id: (organization === '') ? null : organization };
        reportObj.requestType = { id: (requestType === '') ? null : requestType };
        reportObj.priority = { id: (priority === '') ? null : priority };
        reportObj.assetItem = { id: (assetItem === '') ? null : assetItem };
        reportObj.resolverGroup = { id: (resolverGroup === '') ? null : resolverGroup };
        reportObj.resolver = { id: (resolver === '') ? null : resolver };
        reportObj.active = active;

        AxiosInstance.post((reportId === 0) ? REPORT_URL : REPORT_UPDATE_URL, JSON.stringify(reportObj), { responseType: 'text' })
            .then((response) => {

                if (reportId === 0)
                    showAlert("Report created successfully!", "success");
                else
                    showAlert("Report updated successfully!", "success");

                fetchReports();
                setOpen(false);

            })
            .catch((error) => {

                if (reportId === 0)
                    showAlert("Report creation is failed!", "error");
                else
                    showAlert("Report updation is failed!", "error");

                console.error(error);
            });
    }

    return (
        <ThemeProvider>
            <React.Fragment>

                {reportId === 0 ? (
                    <>

                        <Tooltip
                            title="Add Report"
                            onClick={handleClickOpen}
                            style={{ cursor: "pointer", margin: "2px" }}
                        >
                            <IconButton>
                                <AddTaskIcon color="primary" />
                            </IconButton>
                        </Tooltip>
                    </>
                ) : (
                    <Link onClick={handleClickOpen}>{selectedReportName}</Link>
                )}


                <Dialog
                    open={open}
                    onClose={handleClose}
                    PaperProps={{
                        component: "form",
                        onSubmit: (event) => {
                            event.preventDefault();
                            saveReport();
                        },
                    }}
                >
                    <DialogTitle>Add Report</DialogTitle>
                    <DialogContent>
                        <Box
                            component="form"
                            sx={{ "& .MuiTextField-root": { m: 1, width: "50ch" } }}
                            noValidate
                            autoComplete="off"
                        >

                            <div style={{ padding: "0px 0px 0px 30px", align: "center", width: "100%" }}>
                                {/* Filters */}
                                <Grid container spacing={2} sx={{ mb: 2, width: "100%" }}>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            label="Report Name"
                                            name="name"
                                            fullWidth
                                            size="small"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            sx={{ mb: 2, width: "100%" }}
                                            placeholder="Report Name"
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={3}>
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{
                                                display: "block",
                                                fontWeight: 500,
                                                marginLeft: "10px",
                                            }}
                                        >
                                            Organization
                                        </Typography>
                                        <FormControl
                                            size="small"
                                            variant="outlined"
                                            sx={{
                                                m: 1,
                                                minWidth: 200,
                                                width: "100%",
                                                "& .MuiOutlinedInput-root": {
                                                    height: 32,
                                                    "& .MuiSelect-select": {
                                                        fontSize: "0.75rem",
                                                        fontWeight: 500,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        height: "100%",
                                                    },
                                                },
                                            }}
                                        >
                                            <Select
                                                labelId="org-select-label"
                                                id="org-select"
                                                value={organization || ""}
                                                onChange={handleOrgChange}
                                                displayEmpty
                                                renderValue={(selected) => {
                                                    const selectedOrg = (organizations || []).find(
                                                        (org) => org.id === selected
                                                    );
                                                    return selectedOrg ? (
                                                        selectedOrg.name
                                                    ) : (
                                                        <em>Select Organization</em>
                                                    );
                                                }}
                                            >
                                                <MenuItem value="">
                                                    <em>Select Organization</em>
                                                </MenuItem>
                                                {(organizations || []).map((org) => (
                                                    <MenuItem key={org.id} value={org.id}>
                                                        {org.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} md={3}>
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{
                                                display: "block",
                                                fontWeight: 500,
                                                marginLeft: "10px",
                                            }}
                                        >
                                            Request Type
                                        </Typography>
                                        <FormControl
                                            size="small"
                                            variant="outlined"
                                            sx={{
                                                m: 1,
                                                minWidth: 200,
                                                width: "100%",
                                                "& .MuiOutlinedInput-root": {
                                                    height: 32,
                                                    "& .MuiSelect-select": {
                                                        fontSize: "0.75rem",
                                                        fontWeight: 500,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        height: "100%",
                                                    },
                                                },
                                            }}
                                        >
                                            <Select
                                                labelId="request-type-select-label"
                                                id="request-type-select"
                                                value={requestType || ""}
                                                onChange={handleRequestTypeChange}
                                                displayEmpty
                                                renderValue={(selected) => {
                                                    const selectedType = (requestTypes || []).find(
                                                        (rt) => rt.id === selected
                                                    );
                                                    return selectedType ? (
                                                        selectedType.name
                                                    ) : (
                                                        <em>Select Request Type</em>
                                                    );
                                                }}
                                            >
                                                <MenuItem value="">
                                                    <em>Select Request Type</em>
                                                </MenuItem>
                                                {(requestTypes || []).map((rt) => (
                                                    <MenuItem key={rt.id} value={rt.id}>
                                                        {rt.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{
                                                display: "block",
                                                fontWeight: 500,
                                                marginLeft: "10px",
                                            }}
                                        >
                                            Priority
                                        </Typography>
                                        <FormControl
                                            size="small"
                                            variant="outlined"
                                            sx={{
                                                m: 1,
                                                minWidth: 200,
                                                width: "100%",
                                                "& .MuiOutlinedInput-root": {
                                                    height: 32,
                                                    "& .MuiSelect-select": {
                                                        fontSize: "0.75rem",
                                                        fontWeight: 500,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        height: "100%",
                                                    },
                                                },
                                            }}
                                        >
                                            <Select
                                                labelId="priority-select-label"
                                                id="priority-select"
                                                value={priority || ""}
                                                onChange={handlePriorityChange}
                                                displayEmpty
                                                renderValue={(selected) => {
                                                    const selectedPriority = (priorities || []).find(
                                                        (prty) => prty.id === selected
                                                    );
                                                    return selectedPriority ? (
                                                        selectedPriority.name
                                                    ) : (
                                                        <em>Select Priority</em>
                                                    );
                                                }}
                                            >
                                                <MenuItem value="">
                                                    <em>Select Priority</em>
                                                </MenuItem>
                                                {(priorities || []).map((prty) => (
                                                    <MenuItem key={prty.id} value={prty.id}>
                                                        {prty.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{
                                                display: "block",
                                                fontWeight: 500,
                                                marginLeft: "10px",
                                            }}
                                        >
                                            Asset Item
                                        </Typography>
                                        <FormControl
                                            size="small"
                                            variant="outlined"
                                            sx={{
                                                m: 1,
                                                minWidth: 200,
                                                width: "100%",
                                                "& .MuiOutlinedInput-root": {
                                                    height: 32,
                                                    "& .MuiSelect-select": {
                                                        fontSize: "0.75rem",
                                                        fontWeight: 500,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        height: "100%",
                                                    },
                                                },
                                            }}
                                        >
                                            <Select
                                                labelId="asset-item-select-label"
                                                id="asset-item-select"
                                                value={assetItem || ""}
                                                onChange={handleAssetItemChange}
                                                displayEmpty
                                                renderValue={(selected) => {
                                                    const selectedAsset = (assetItems || []).find(
                                                        (ai) => ai.id === selected
                                                    );
                                                    return selectedAsset ? (
                                                        selectedAsset.name
                                                    ) : (
                                                        <em>Select Asset Item</em>
                                                    );
                                                }}
                                            >
                                                <MenuItem value="">
                                                    <em>Select Asset Item</em>
                                                </MenuItem>
                                                {(assetItems || []).map((ai) => (
                                                    <MenuItem key={ai.id} value={ai.id}>
                                                        {ai.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{
                                                display: "block",
                                                fontWeight: 500,
                                                marginLeft: "10px",
                                            }}
                                        >
                                            Resolver Group
                                        </Typography>
                                        <FormControl
                                            size="small"
                                            variant="outlined"
                                            sx={{
                                                m: 1,
                                                minWidth: 200,
                                                width: "100%",
                                                "& .MuiOutlinedInput-root": {
                                                    height: 32,
                                                    "& .MuiSelect-select": {
                                                        fontSize: "0.75rem",
                                                        fontWeight: 500,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        height: "100%",
                                                    },
                                                },
                                            }}
                                        >
                                            <Select
                                                labelId="resolver-group-select-label"
                                                id="resolver-group-select"
                                                value={resolverGroup || ""}
                                                onChange={handleResolverGroupChange}
                                                displayEmpty
                                                renderValue={(selected) => {
                                                    const selectedGroup = (resolverGroups || []).find(
                                                        (rg) => rg.id === selected
                                                    );
                                                    return selectedGroup ? (
                                                        selectedGroup.name
                                                    ) : (
                                                        <em>Select Resolver Group</em>
                                                    );
                                                }}
                                            >
                                                <MenuItem value="">
                                                    <em>Select Resolver Group</em>
                                                </MenuItem>
                                                {(resolverGroups || []).map((rg) => (
                                                    <MenuItem key={rg.id} value={rg.id}>
                                                        {rg.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} md={3}>
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{
                                                display: "block",
                                                fontWeight: 500,
                                                marginLeft: "10px",
                                            }}
                                        >
                                            Resolver
                                        </Typography>
                                        <FormControl
                                            size="small"
                                            variant="outlined"
                                            sx={{
                                                m: 1,
                                                minWidth: 200,
                                                width: "100%",
                                                "& .MuiOutlinedInput-root": {
                                                    height: 32,
                                                    "& .MuiSelect-select": {
                                                        fontSize: "0.75rem",
                                                        fontWeight: 500,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        height: "100%",
                                                    },
                                                },
                                            }}
                                        >
                                            <Select
                                                labelId="resolver-select-label"
                                                id="resolver-select"
                                                value={resolver || ""}
                                                onChange={handleResolverChange}
                                                displayEmpty
                                                renderValue={(selected) => {
                                                    const selectedResolver = (resolvers || []).find(
                                                        (res) => res.id === selected
                                                    );
                                                    return selectedResolver ? (
                                                        selectedResolver.user?.name || selectedResolver.name
                                                    ) : (
                                                        <em>Select Resolver</em>
                                                    );
                                                }}
                                            >
                                                <MenuItem value="">
                                                    <em>Select Resolver</em>
                                                </MenuItem>
                                                {(resolvers || []).map((res) => (
                                                    <MenuItem key={res.id} value={res.id}>
                                                        {res.user?.name || res.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={6} md={3}>
                                        <FormControl>
                                            <FormLabel id="demo-row-radio-buttons-group-label">
                                                Active
                                            </FormLabel>
                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                                value={active}
                                                onChange={handleStatusChange}
                                            >
                                                <FormControlLabel
                                                    value={true}
                                                    control={<Radio />}
                                                    label="Yes"
                                                />
                                                <FormControlLabel
                                                    value={false}
                                                    control={<Radio />}
                                                    label="No"
                                                />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>

                                    {/* <Grid
                    item
                    xs={12}
                    md={3}
                    style={{ marginTop: "auto", marginBottom: "7px" }}
                    >
                    <ReportScheduleDialog />


                   
                    </Grid> */}
                                </Grid>
                            </div>

                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button type="submit">Add </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        </ThemeProvider>
    );
}
export default ReportDialog;
